import { render, staticRenderFns } from "./WorldClock.vue?vue&type=template&id=35b69f94&scoped=true&"
import script from "./WorldClock.vue?vue&type=script&lang=js&"
export * from "./WorldClock.vue?vue&type=script&lang=js&"
import style0 from "./WorldClock.vue?vue&type=style&index=0&id=35b69f94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b69f94",
  null
  
)

export default component.exports